import React from 'react';
export type Receipt = 'sent'|'delivered'|'read'|'queued'|'failed'|'unknown';
export default function MessageReceipt({status}:{status:Receipt}) {
 const labels = {sent:'Sent',delivered:'Delivered',read:'Read',queued:'Queued — waiting to send',failed:'Failed to send',unknown:'Delivery record unavailable'};
 const double = status==='delivered'||status==='read';
 return <span title={labels[status]} aria-label={labels[status]} style={{display:'inline-flex',color:status==='read'?'#1684d8':'#737373',verticalAlign:'middle',marginLeft:4}}>
  {status==='sent'||double ? <svg width={double?22:15} height="16" viewBox={double?'0 0 22 16':'0 0 15 16'} fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="m1 8 4 4L14 3"/>{double&&<path d="m9 10 2 2 9-9"/>}</svg> : <span>{status==='queued'?'◷':status==='failed'?'!':'?'}</span>}
 </span>;
}
export function conversationReceipt(message:any, activity:any[]):Receipt {
 const text = (message.text||'').replace(/^\[human\]\s*/, '');
 const matches = (activity||[]).filter(d=>d.text===text && Math.abs(Date.parse(d.created_at)-Date.parse(message.ts))<120000);
 // Ambiguous repeated text must not borrow another message's receipt.
 if(matches.length!==1) return 'unknown';
 const row=matches[0];
 if(row.receipt_status==='read') return 'read';
 if(row.receipt_status==='delivered') return 'delivered';
 if(row.receipt_status==='failed'||['failed','manual_failed','dead'].includes(row.status)) return 'failed';
 if(row.channel!=='whatsapp'&&row.delivered_at) return 'delivered';
 if(row.send_confirmed_at) return 'sent';
 if(['queued','processing','manual_sending'].includes(row.status)) return 'queued';
 return 'unknown';
}
